import TimerDecorator from './TimerDecorator';
import $ from 'jquery';

/*
Concrete decorator for Timer at page level
*/
class TimerPage extends TimerDecorator {
  constructor(countdown, $domEl) {
    super(countdown, $domEl);
    return this;
  }

  startTimer() {
    super.startTimer();
    this.pageChange();
  }

  pageChange() {
    // if url changes, interval is cleared.
    $(window).on('hashchange', () => {
      clearInterval(this.interval);
      // if (timer is included in URL)
      super.startTimer();
    });
  }
  stopTimer() {
    super.stopTimer();
  }

  resetTimer() {
    super.resetTimer();
  }
}

export default TimerPage;
